module.exports = __webpack_public_path__ + "static/img/no1-icon.537be978.png";